// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__2sAVu","title":"style_title__YJB4G","text":"style_text__L60lN","navigate":"style_navigate__6QVz+"};